// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.validation {
    margin-right: 200px;
    margin-left: 200px;
}

.validationLivres {
    margin-top:50px;
}

.validationLivre1, .validationLivre2 {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
}

.validationLivre1 img, .validationLivre2 img {
    width: 100%;
    margin-top: -55px;
    margin-left: 15px;
}

.validationLivre1 .btn, .validationLivre2 .btn {
    z-index: 5;
}

/* Responsive */
@media (max-width:991px) {
    .validationLivres {
        margin-top:20px;
    }
    .validationLivre1 img, .validationLivre2 img {
        margin-left:0;
    }
    .validation {
        margin-right: 50px;
        margin-left: 50px;
    }
}

@media (max-width:767px) {
    .validation {
        margin-right: 0;
        margin-left: 0;
    }

    .validationLivre1 img, .validationLivre2 img {
        width:70%;
    }
    .validationLivre1 img {
        margin-bottom:50px;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/Validation.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA,eAAe;AACf;IACI;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,SAAS;IACb;IACA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".validation {\n    margin-right: 200px;\n    margin-left: 200px;\n}\n\n.validationLivres {\n    margin-top:50px;\n}\n\n.validationLivre1, .validationLivre2 {\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex-wrap: nowrap;\n}\n\n.validationLivre1 img, .validationLivre2 img {\n    width: 100%;\n    margin-top: -55px;\n    margin-left: 15px;\n}\n\n.validationLivre1 .btn, .validationLivre2 .btn {\n    z-index: 5;\n}\n\n/* Responsive */\n@media (max-width:991px) {\n    .validationLivres {\n        margin-top:20px;\n    }\n    .validationLivre1 img, .validationLivre2 img {\n        margin-left:0;\n    }\n    .validation {\n        margin-right: 50px;\n        margin-left: 50px;\n    }\n}\n\n@media (max-width:767px) {\n    .validation {\n        margin-right: 0;\n        margin-left: 0;\n    }\n\n    .validationLivre1 img, .validationLivre2 img {\n        width:70%;\n    }\n    .validationLivre1 img {\n        margin-bottom:50px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
